// extracted by mini-css-extract-plugin
export default {"underDevelopmentContainer":"UnderDevelopment_underDevelopmentContainer__0PfrQ"};